export default __webpack_public_path__ + "static/stars-a297541d7b2415c382572152d9cc79f8.jpg";